import { useState, useContext } from 'react'
import WODetailsModal from '../sub-modals/WODetailsSubModal'
import styles from './styles.module.css'
import { WoDetailContext } from '../../../context/context'
import {
  CANCELLED_STATUSES,
  STATUSES,
} from '../../../../../global/constants/order-status'
import { ROLES } from '../../../../../global/constants/users'
import { ROUTING_ALGORITHMS } from '../../../../../global/constants/scheduling'
import { SUB_MODAL_NAMES } from '../sub-modals/constants'

export default function AdditionalActions() {
  const { data: order } = useContext(WoDetailContext)

  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [modalName, setModalName] = useState<string>('')

  function handleOpen(e: any) {
    setModalName(e.target.innerText)
    setModalOpen(true)
  }
  function handleClosed() {
    setModalOpen(false)
    setModalName('')
  }

  //force appointment and force move should only be accessible to users with role = admin
  const userRole = localStorage.getItem('Role')
  const isUserAdmin = userRole === ROLES.admin

  // The CS Team should not be able to move a work order to scheduled if we do
  // not have a payment method token stored in associated invoices.
  const shouldEnableQuoteToScheduled =
    (order?.invoices?.find((invoice: any) => invoice.paymentMethodToken) ||
      order?.freeOrderReason) &&
    order?.status === STATUSES.quote
  const shouldEnablePendingToScheduled =
    (order?.invoices?.find((invoice: any) => invoice.paymentMethodToken) ||
      order?.freeOrderReason) &&
    order?.status === STATUSES.reschedule
  const shouldEnableResendInvoice = order?.status === STATUSES.completed
  const shouldEnableScheduledToPending = order?.status === STATUSES.scheduled
  const shouldEnableCompleteWorkOrder =
    ![...CANCELLED_STATUSES, STATUSES.completed].includes(
      order?.status ?? '',
    ) &&
    (order?.invoices?.find((invoice) => invoice.paymentMethodToken) ||
      order?.freeOrderReason) &&
    order?.status !== STATUSES.quote
  const shouldDisableForceMoveAndForceAppointment =
    !isUserAdmin ||
    [...CANCELLED_STATUSES, STATUSES.completed].includes(order?.status ?? '')

  return (
    <div>
      <div className={styles.heading}>Additional Actions</div>
      <WODetailsModal
        isOpen={modalOpen}
        handleClosed={handleClosed}
        actionName={modalName}
      />
      <div className={styles.container}>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
          disabled={!shouldEnableCompleteWorkOrder}
        >
          {SUB_MODAL_NAMES.COMPLETE_WORK_ORDER}
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
          disabled={shouldDisableForceMoveAndForceAppointment}
        >
          {SUB_MODAL_NAMES.FORCE_APPOINTMENT}
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
          disabled={!shouldEnableScheduledToPending}
        >
          {SUB_MODAL_NAMES.ADD_TO_RESCHEDULED_QUEUE}
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
        >
          {SUB_MODAL_NAMES.CHANGE_ADDRESS}
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
          disabled={!shouldEnableResendInvoice}
        >
          {SUB_MODAL_NAMES.RESEND_INVOICE}
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
        >
          {SUB_MODAL_NAMES.CLONE_ORDER}
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
        >
          {SUB_MODAL_NAMES.INSTALLATION_IMAGES}
        </button>
      </div>
    </div>
  )
}
